module.exports = __webpack_public_path__ + "img/ClickForSound_8.e75a583d.png";